import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, " / Supported Files", -1 /* HOISTED */)
const _hoisted_2 = { class: "Docs-Page-Supported-Files" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Here is the list of supported extensions as well as which node can be used to import those files:", -1 /* HOISTED */)
const _hoisted_4 = { class: "list-none" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("td", null, "Extension"),
  /*#__PURE__*/_createElementVNode("td", null, "Nodes")
], -1 /* HOISTED */)
const _hoisted_6 = { class: "group my-1" }
const _hoisted_7 = { class: "group-hover:bg-gray-900" }
const _hoisted_8 = { class: "group-hover:bg-gray-900" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Here is the inverted list, which is the extension that a specific node can import:", -1 /* HOISTED */)
const _hoisted_10 = { class: "list-none" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("td", null, "Nodes"),
  /*#__PURE__*/_createElementVNode("td", null, "Extensions")
], -1 /* HOISTED */)
const _hoisted_12 = { class: "my-1 group" }
const _hoisted_13 = { class: "group-hover:bg-gray-900" }
const _hoisted_14 = { class: "group-hover:bg-gray-900" }
const _hoisted_15 = { class: "mr-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", null, "What's next?", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DocRouterLink = _resolveComponent("DocRouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", null, [
      _createVNode(_component_router_link, { to: _ctx.assetsRoute }, {
        default: _withCtx(() => [
          _createTextVNode("Import Assets")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]),
      _hoisted_1
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("table", _hoisted_4, [
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extensions, (extension, i) => {
          return (_openBlock(), _createElementBlock("tr", _hoisted_6, [
            _createElementVNode("td", _hoisted_7, "." + _toDisplayString(extension), 1 /* TEXT */),
            _createElementVNode("td", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodesRoutesForExtensions[i], (route, j) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  class: "mr-2",
                  to: route
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.nodeLinkLabelsForExtensions[i][j]), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _hoisted_9,
      _createElementVNode("table", _hoisted_10, [
        _hoisted_11,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodes, (_, i) => {
          return (_openBlock(), _createElementBlock("tr", _hoisted_12, [
            _createElementVNode("td", _hoisted_13, [
              _createVNode(_component_router_link, {
                class: "mr-2",
                to: _ctx.nodeRoutes[i]
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.nodeLabels[i]), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
            ]),
            _createElementVNode("td", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extensionsForNode[i], (extension) => {
                return (_openBlock(), _createElementBlock("span", _hoisted_15, "." + _toDisplayString(extension), 1 /* TEXT */))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _hoisted_16,
      _createElementVNode("p", null, [
        _createTextVNode("Let's see "),
        _createVNode(_component_DocRouterLink, {
          bang: "",
          href: _ctx.nextRoute,
          innerText: "how the editor works →"
        }, null, 8 /* PROPS */, ["href"])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}